export function safeCastToEnum<T extends Record<string, string | number>>(
    value: any,
    enumType: T,
): T[keyof T] {
    const enumKeys = Object.keys(enumType).join(', ')
    const enumValues = Object.values(enumType).join(', ')

    if (Object.values(enumType).includes(value)) {
        return value as T[keyof T]
    }

    throw new Error(
        `Invalid value "${value}" for enum {${enumKeys}}. Expected one of: ${enumValues}`,
    )
}
